<template>
  <svg class="c-icon" :class="modifier" role="presentation" aria-hidden="true">
    <use v-bind="{ 'xlink:href': iconPath }"></use>
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    modifier: String,
    icon: String,
  },
  computed: {
    iconPath() {
      return `${this.$settings('assetsFolder')}dist/sprite.svg#icon-${
        this.icon
      }`
    },
  },
}
</script>
